(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price-display"] && !Shopify.designMode) return;
  try {
    (function () {
  var displaySelector = '[data-pd-follow-picker]';

  function readPrice(text) {
    var amount = text.replace(/[^0-9.,-]/g, '');
    // A final separator followed by one or two digits is a decimal mark.
    var decimal = amount.match(/[.,]([0-9]{1,2})$/);
    if (decimal) {
      amount = amount.slice(0, decimal.index).replace(/[.,]/g, '') + '.' + decimal[1];
    } else {
      amount = amount.replace(/[.,]/g, '');
    }
    return amount ? Number(amount) : NaN;
  }

  function update(display, radio) {
    var card = radio.closest('label') || (radio.labels && radio.labels[0]);
    if (!card) return;
    var sale = card.querySelector('.qps-sale-price');
    if (!sale || !sale.textContent.trim()) return;
    var original = card.querySelector('.qps-orig-price');
    var price = display.querySelector('.pd-price');
    if (!price) return;
    var compare = display.querySelector('.pd-was');
    if (!compare) {
      compare = document.createElement('span');
      compare.className = 'pd-was';
      price.after(compare);
    }
    var discount = display.querySelector('.pd-discount');
    price.textContent = sale.textContent.trim();
    compare.textContent = original ? original.textContent.trim() : '';
    compare.style.display = compare.textContent ? '' : 'none';
    var saveBadge = display.querySelector('.pd-save');
    if (saveBadge) saveBadge.style.display = 'none';

    var saleAmount = readPrice(price.textContent);
    var originalAmount = readPrice(compare.textContent);
    var percent = Math.floor((originalAmount - saleAmount) * 100 / originalAmount + 1e-9);
    if (!(saleAmount >= 0 && originalAmount > saleAmount && percent > 0)) {
      if (discount) discount.style.display = 'none';
      return;
    }

    if (!discount) {
      discount = document.createElement('span');
      discount.className = 'pd-discount';
      display.appendChild(discount);
    }
    discount.textContent = percent + '% OFF';
    discount.style.display = '';
  }

  function updateSection(section, selected) {
    if (!section) return;
    var radio = selected || section.querySelector('.qps-radio:checked');
    if (!radio) return;
    section.querySelectorAll(displaySelector).forEach(function (display) {
      if (display.closest('.shopify-section') === section) update(display, radio);
    });
  }

  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (radio.matches && radio.matches('.qps-radio:checked')) {
      updateSection(radio.closest('.shopify-section'), radio);
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    updateSection(event.target);
  });

  function initialize() {
    document.querySelectorAll('.shopify-section').forEach(function (section) {
      if (section.querySelector(displaySelector)) updateSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
